module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Swerling, Ralph Lazar\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lisa Swerling and Ralph Lazar are famed illustrators, the authors of the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestseller "), _c('I', [_vm._v("Me Without You")]), _vm._v(", and the creators of the internationally beloved brand "), _c('I', [_vm._v("Happiness Is ...")]), _vm._v(" They live in Marin County, California.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RYXYBp/tc-custom/9781452140834.jpg?1702235577122",
      "alt": "This image is the cover for the book Happiness Is . . . 500 Things to Be Happy About"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Happiness Is . . . 500 Things to Be Happy About\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From "), _c('i', [_vm._v("New York Times–")]), _vm._v("bestselling authors, an uplifting cartoon collection celebrating life’s simple joys—the perfect gift for friends or family.")]), _c('br'), _c('br'), _vm._v("From Ralph Lazar and Lisa Swerling, famed illustrators and the authors of "), _c('i', [_vm._v("Me Without You")]), _vm._v(", this adorable gift book illustrates 500 things to be happy about. Happiness is . . . an unexpected bouquet, cheese, fixing something, a good high-five, and so much more! The charming, make-you-smile illustrations hit just the right note—not too sappy, not too sweet—and remind us that there are dozens of things to be happy about every day. A universally appealing book for any little pick-me-up, this cheerful collection is sure to be a hit year after year!"), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0